import { useMemo } from "react";
import { unifyDate } from "src/utils";
import { v4 } from "uuid";

import MedicalDynamic from "../sections/DynamicSection/MedicalDynamic";
import { datecreatedProp, defaultData } from "../utils/defaultData";

interface Props {
  dataKey: string | undefined;
  row: any;
}

const ModalGenerator = ({ dataKey, row }: Props) => {
  const section = useMemo(() => {
    const matchingSection = defaultData.others.find(
      section => section.dataKey === dataKey,
    );
    if (!matchingSection) return null;

    const filledRows = {
      rows: [
        {
          inputs: matchingSection.rows[0].inputs.map((input: any) => ({
            ...input,
            value:
              input.name === datecreatedProp && row[input.name]
                ? unifyDate(row[input.name])
                : row[input.name],
            id: v4(),
          })),
        },
      ],
    };

    return {
      name: matchingSection.name,
      dataKey,
      sectionId: v4(),
      headers: matchingSection.headers, // headers:
      ...filledRows,
    } as any;
  }, [dataKey, row]);

  if (!section) return null;
  return <MedicalDynamic {...section} history />;
};
export default ModalGenerator;
